"use client";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

type Props = {
  open: boolean;
  onOpenChange: (v: boolean) => void;
};

const SHORTCUTS: { keys: string[]; desc: string; group: string }[] = [
  { keys: ["Tab"], desc: "Alternar modo: palavra → frase → parágrafo", group: "Seleção" },
  { keys: ["Shift", "Tab"], desc: "Alternar modo na ordem inversa", group: "Seleção" },
  { keys: ["→"], desc: "Próxima palavra / frase / parágrafo (no modo atual)", group: "Seleção" },
  { keys: ["←"], desc: "Anterior palavra / frase / parágrafo", group: "Seleção" },
  { keys: ["↑", "PgUp"], desc: "Rolar texto para cima", group: "Navegação" },
  { keys: ["↓", "PgDn", "Espaço"], desc: "Rolar texto para baixo", group: "Navegação" },
  { keys: ["Home"], desc: "Ir para o início", group: "Navegação" },
  { keys: ["End"], desc: "Ir para o fim", group: "Navegação" },
  { keys: ["+"], desc: "Aumentar fonte", group: "Tipografia" },
  { keys: ["−"], desc: "Diminuir fonte", group: "Tipografia" },
  { keys: ["D"], desc: "Alternar tema claro / escuro", group: "Geral" },
  { keys: ["T"], desc: "Ouvir seleção atual (text-to-speech)", group: "Geral" },
  { keys: ["S"], desc: "Salvar palavra no vocabulário", group: "Geral" },
  { keys: ["M"], desc: "Abrir configurações de leitura", group: "Geral" },
  { keys: ["?"], desc: "Mostrar esta ajuda", group: "Geral" },
];

export function ShortcutsHelp({ open, onOpenChange }: Props) {
  const groups = Array.from(new Set(SHORTCUTS.map((s) => s.group)));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Atalhos do teclado</DialogTitle>
          <DialogDescription>
            Tudo no ReadFluent pode ser feito com o teclado. O app é otimizado para PC.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-5 max-h-[60vh] overflow-y-auto pr-1">
          {groups.map((g) => (
            <div key={g}>
              <h4 className="text-xs uppercase tracking-wide text-muted-foreground font-medium mb-2">
                {g}
              </h4>
              <div className="space-y-1.5">
                {SHORTCUTS.filter((s) => s.group === g).map((s, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between gap-3 text-sm py-1"
                  >
                    <span className="text-muted-foreground">{s.desc}</span>
                    <div className="flex items-center gap-1 shrink-0">
                      {s.keys.map((k, j) => (
                        <kbd
                          key={j}
                          className="px-1.5 min-w-[24px] text-center py-0.5 text-[10px] font-mono font-medium rounded border bg-muted"
                        >
                          {k}
                        </kbd>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
